<script lang="ts">
export default {
  name: 'OwnershipTypeFilter',
};
</script>

<script setup lang="ts">
import { computed, onMounted, reactive } from 'vue';
import FilterButton from '@/components/FilterButton.vue';

const emit = defineEmits<{
  (e: 'update:showPublic', value: boolean): void;
  (e: 'update:showPrivate', value: boolean): void;
}>();

const props = defineProps<{
  showPublic: boolean,
  showPrivate: boolean,
}>();

// -----
// data
// -----

const selected = reactive({
  showPublic: false,
  showPrivate: false,
});

// ----------
// functions
// ----------

function apply() {
  emit('update:showPublic', selected.showPublic);
  emit('update:showPrivate', selected.showPrivate);
}

// -----------
// lifecycles
// -----------

onMounted(() => {
  selected.showPublic = props.showPublic;
  selected.showPrivate = props.showPrivate;
});

const title = computed(() => {
  const title = [selected.showPublic ? 'Public' : '', selected.showPrivate ? 'Private' : ''];
  const str: string = title.filter(t => !!t).join('; ');
  return str || 'Ownership Type';
});

</script>

<template>
  <FilterButton :title="title" :active="props.showPublic || props.showPrivate" @close="apply()">
    <template #menu="{ close }">
      <div class="menu">
        <div class="fields">

          <div>
            <h4>Ownership Type</h4>

            <div class="wrapper">
              <div class="field">
                <label for="showPublic">
                  <input id="showPublic" type="checkbox" v-model="selected.showPublic"/>
                  <span>Public</span>
                </label>
              </div>

              <div class="field">
                <label for="showPrivate">
                  <input id="showPrivate" type="checkbox" v-model="selected.showPrivate"/>
                  <span>Private</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons">
          <v-btn size="small" variant="outlined" @click="selected.showPublic=false;selected.showPrivate=false">Clear</v-btn>
          <v-btn size="small" variant="flat" color="primary" @click="close()" data-test="filter-ownership-type-apply">Apply</v-btn>
        </div>
      </div>
    </template>
  </FilterButton>
</template>
